module.exports = __webpack_public_path__ + "static/media/klefki-logo.b003dab7.png";